<div #f2title id="wrapper" data-module-name="DemoMarketsOverviewPage">
	<div class="row f2-Title">
		<div class="col-xs-12">
			<h1>{{displayTitle}}</h1>
		</div>
	</div>
</div>